export default "__VITE_ASSET__d43c2d9e__"